module.exports = __webpack_public_path__ + "img/logo-avion.16563f5c.png";